import { GeneralObject } from '@scansource-brazil/zeus-core-ui/types';
import { adaptFilterOption, formatToISODate } from './helpers';

export type SalesCommissionFiltersDto = {
  genericTerm?: string;
  filteredField?: string;
  paymentDateStart?: string;
  paymentDateEnd?: string;
  dueDateStart?: string;
  dueDateEnd?: string;
  startDate?: string;
  endDate?: string;
  commissionStatus?: string | number;
  currentPage?: number;
  pageSize?: number;
  sort?: string;
  sortName?: string;
};

export class SalesCommissionFilters {
  filterOption?: string;
  filterValue?: string;
  paymentDate?: Date[];
  dueDate?: Date[];
  commissionStatus?: string;
  date?: Date[];

  toDto(model: SalesCommissionFilters) {
    const dto = {} as SalesCommissionFiltersDto;

    const filterOptions = adaptFilterOption(model);
    dto.genericTerm = filterOptions?.genericTerm;
    dto.filteredField = filterOptions?.filteredField;
    dto.commissionStatus = model.commissionStatus;
    dto.paymentDateStart = model.paymentDate && this.adaptDateRangeParams(model.paymentDate)?.start;
    dto.paymentDateEnd = model.paymentDate && this.adaptDateRangeParams(model.paymentDate)?.end;
    dto.dueDateStart = model.dueDate && this.adaptDateRangeParams(model.dueDate)?.start;
    dto.dueDateEnd = model.dueDate && this.adaptDateRangeParams(model.dueDate)?.end;
    if (model.date) {
      dto.startDate = this.adaptDateRangeParams(model.date)?.start;
      dto.endDate = this.adaptDateRangeParams(model.date)?.end;
    } else if (model.dueDate) {
      // Use dueDate for startDate/endDate if no explicit date but dueDate exists
      dto.startDate = this.adaptDateRangeParams(model.dueDate)?.start;
      dto.endDate = this.adaptDateRangeParams(model.dueDate)?.end;
    } else if (model.paymentDate) {
      // Use paymentDate for startDate/endDate if no other date available
      dto.startDate = this.adaptDateRangeParams(model.paymentDate)?.start;
      dto.endDate = this.adaptDateRangeParams(model.paymentDate)?.end;
    }

    return { ...dto };
  }

  constructor(data?: Partial<SalesCommissionFilters>) {
    if (!data) return;
    Object.assign(this, data);
  }

  setFilters(data: Partial<SalesCommissionFilters>) {
    if (!data) return;
    this.filterOption = data.filterOption;
    this.filterValue = data.filterValue;
    this.paymentDate = data.paymentDate;
    this.dueDate = data.dueDate;
    this.commissionStatus = data.commissionStatus;
  }

  updateFilters(data: Partial<SalesCommissionFilters>) {
    if (!data) return;
    Object.assign(this, data);
  }

  resetFilters() {
    Object.assign(this, new SalesCommissionFilters());
  }

  adaptDateRangeParams(dateRange: Date[]): GeneralObject | undefined {
    const [start, end] = dateRange;
    if (!start) return undefined;

    const output = {} as GeneralObject;
    output.start = formatToISODate(start);
    output.end = end ? formatToISODate(end) : formatToISODate(start);

    return { ...output };
  }

  static adapter(data: SalesCommissionFilters) {
    return new SalesCommissionFilters(data).toDto(data);
  }
}
